import FormicaMultiSelectBox from '../custom/FormicaMultiSelectBox';
import { FormicaSelectBoxItem } from '../custom/FormicaSearchSelectBox';
import useDashboardEmailCharts from './useDashboardEmailCharts';

interface Props {
  dashboardChartIds: string[];
  dashboardKey: string | undefined;
  selectedChartIds: string[];
  onChange: (items: FormicaSelectBoxItem[]) => void;
}

function DashboardEmailChartSelectComponent({ dashboardChartIds, dashboardKey, selectedChartIds, onChange }: Props) {
  const { options, selectedItems } = useDashboardEmailCharts(dashboardChartIds, dashboardKey, selectedChartIds);

  return <FormicaMultiSelectBox selectedItems={selectedItems} onChange={onChange} options={options} />;
}

export default DashboardEmailChartSelectComponent;
